import { MarkdownProps } from 'react-native-markdown-display'

/**
 * Spacing / layout defaults merged (per element key) over the library
 * stylesheet. Typography (font, size, color) comes from the render rules —
 * tune layout here, text appearance via the `variant` / `headingVariants`
 * props on `<Markdown>`.
 */
export const defaultMarkdownStyles = {
  body: {
    margin: 0,
    padding: 0,
  },
  paragraph: {
    marginTop: 0,
    marginBottom: 12,
  },
  heading1: { marginTop: 0, marginBottom: 16 },
  heading2: { marginTop: 0, marginBottom: 14 },
  heading3: { marginTop: 0, marginBottom: 12 },
  heading4: { marginTop: 0, marginBottom: 12 },
  heading5: { marginTop: 0, marginBottom: 8 },
  heading6: { marginTop: 0, marginBottom: 8 },
  bullet_list: {
    marginBottom: 12,
    gap: 8,
  },
  ordered_list: {
    marginBottom: 12,
    gap: 8,
  },
  bullet_list_icon: {
    marginLeft: 0,
    marginRight: 12,
  },
  ordered_list_icon: {
    marginLeft: 0,
    marginRight: 12,
  },
  softbreak: {},
  hardbreak: {},
} as const satisfies MarkdownProps['style']
